<template>
  <div class="line">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'LineWrap' // LineがVueで予約語扱いなのでWrap付ける
}
</script>
